import React from 'react';
import { connect } from 'react-redux'

export default (selectorFunction) => {
    const component = (props) => {
        const Container = selectorFunction(props);
        return <Container />
    }

    return connect(s => s)(component)
}